import React from "react";

export default function DeniedCard() {
  return (
    <div className="page-shell flex items-center justify-center px-4">
      <div className="card max-w-md w-full p-6 text-center">
        <h1 className="text-2xl font-semibold text-red-600 mb-4">Toegang geweigerd</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          U heeft geen beheerrechten om deze pagina te bekijken.
        </p>
        <a href="/" className="btn-primary">Terug naar kalender</a>
      </div>
    </div>
  );
}
